import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_USERS_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetUsersAction(data.users));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setUsers as SetUsers
}